import { Component, OnDestroy, OnInit, ViewChild, Input, TemplateRef, ViewContainerRef, } from '@angular/core';

import { MysqlService } from './../../../../services/mysql.service';
import { SubjectAttendence } from './../../../../api/subjectAttenence';
import {DemoService} from '../../../../demo.service';

import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-subject-attendence',
  templateUrl: './subject-attendence.component.html',
  styleUrls: ['./subject-attendence.component.css']
})
export class SubjectAttendenceComponent implements OnInit {

  @Input() subject_id: number;
  @Input() job_id: number;

  model: SubjectAttendence;

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: Object;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  get_latest_subject_note_id: Object;

  public mytime: Date = new Date();
 
  staffList: Object;
  get_latest_subject_attendence_id: any;
  subject_attendence: any;
  brands: Object;
  users: Object;
  users_attended: Object;
  assignedList: Object;
  assignedBrandList: any;
  current_service_number: Object;
  converted_service_number: number;

  constructor(
    private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    private modalService: BsModalService,
    public toastr: HotToastService,
    vcr: ViewContainerRef
  ) { 

    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUsername = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;
    this.brand_id = this.sessionBrandId;

  }

  ngOnInit() {
    // this.getBrandUsers('94'); // for the drop down
    this.getSubjectAgentBrandsAssigned(this.subject_id);
    this.getSubjectAttendence(this.subject_id);

    this.model = new SubjectAttendence();
    this.model.date_attended = this.mytime;
    this.model.time_attended = this.mytime;
    this.model.who_attended = this.sessionBrandId;
  }

 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}

getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { this.assignedBrandList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }

// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }

 getSubjectAgentAssigned(subject_id) {
  this._demoService.getSubjectAgentsAssigned(subject_id).subscribe(
     data => { this.assignedList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 createSubjectAttendence(model) {
  this.model.subject_id = this.subject_id;
  this.model.job_id = this.job_id;
  this.model.created_by = this.sessionUserId;
  this._demoService.createSubjectAttendence(model).subscribe(
       data => {  this.get_latest_subject_attendence_id = data; // this is the retuned json upon creation.
        // this.getTraceCandidateNotes(this.trace_candidate_id);

       // CreateJob3Component.getTraceCandidateNotes();

       // CreateJob3Component.returned.next(false);
        this.toastr.info('Addendence Entered!');
         this.getSubjectAttendence(this.subject_id); // old staff list of sharmans. (allocated Agents)
         this.getSubjectAgentAssigned(this.subject_id);
         //  return true;
       },
       error => {
         // console.log(error(error));
         //return console.log(error);
       }
  );
  }



  getSubjectAttendence(subject_id) {
    this._demoService.getSubjectAttendence(subject_id).subscribe(
      data => { this.subject_attendence = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
       let res = data[0];
       // this.getUsersById(res.who_attended);
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }


    deleteSubjectAttendence(attendence_id) {
      if (confirm('Are you sure you want to delete this attendance note? ')) {
        this._demoService.deleteSubjectAttendence(attendence_id).subscribe(
           data => {
            this.getSubjectAttendence(this.subject_id);
             return true;
           },
           error => {
             console.error('Error deleting Attendence!');
            return console.log(error);
           }
        );
    }
    }



    getBrandById(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        data => { this.brands = data; },
        err => console.error(err),
         () => console.log('done loading brand')
      );
      }
    
    
      getUsersById(user_id) {
        this._demoService.getUsersById(user_id).subscribe(
          data => { this.users_attended = data;
           // console.log("Done loadng USER");
           // console.log(this.users);
          // this.users_updated = data;
          },
          error => {
            console.error('Error Loading User!');
          return console.log(error);
          }
        ); }




                // for select items
                onChangeAttendanceCount(model) {
                  this.model.attendence_number = 0;   
                  model.job_id = this.job_id;
                  model.subject_id = this.subject_id;
                 // look (count) up job_id, subject_id, agent id attendences + 1
                 this.getJobSubjectAttendancesCountNumber(model);
                // set model.service_number = results.
                 

                 }


                 getJobSubjectAttendancesCountNumber(model){
                  this._demoService.getJobSubjectAttendancesCountNumber(model).subscribe(
                    data => { this.current_service_number = data; 
                      this.converted_service_number = Number(this.current_service_number);
                                        // this.selectedEntry = entry;
                  let increment = Number(this.converted_service_number + 1);
                  this.model.attendence_number = increment; // changes or updates via selection of radio button group

                    console.log(data);
                    },
                    err => {console.error(err)
                      // set to one if there is an error because it means subject id cannot be found
                      this.model.attendence_number = 1;
                    },
                  );

                 }
        

}
